export const enum EhrPageNames {
    Profile = 'profile',
    MedicalCaseList = 'cases',
    EntryList = 'entry',
    TreatmentPlan = 'treatmentsPlan',
    Subscription = 'programs',
    RenderedService = 'services',
    Notifications = 'notifications',
    Vaccination = 'vaccination',
    Agreements = 'agreements',
    Programs = 'programs',
    Attachments = 'attachments',
    SubscriptionOrder = 'subscription-order',
    RecurringSubscriptions = 'recurring-subscriptions',
}
